module.exports = __webpack_public_path__ + "static/media/Completed.b6ba1c28.png";